import { takeLatest, put, call } from 'redux-saga/effects';
import firebase from 'firebase/app';
import localforage from 'localforage';

import {
	GET_VIDEOS,
	SET_VIDEOS,
	GET_VIDEOS_PROM,
	SET_VIDEOS_PROM,
	GET_VIDEOS_TESTI,
	SET_VIDEOS_TESTI,
	GET_HOME_VIDEO,
	SET_HOME_VIDEO,
	SET_HOME_SHOW_VIDEO,
	SET_MENU_HIDE
} from '../actions/Types';

export function* videosSaga() {
	yield takeLatest(GET_VIDEOS, getVideos);
	yield takeLatest(GET_VIDEOS_PROM, getVideosProm);
	yield takeLatest(GET_VIDEOS_TESTI, getVideosTesti);
	yield takeLatest(GET_HOME_VIDEO, getHomeVideo);
}

function* getVideos() {
	try {
		const videos = yield call(firebaseGet);
		yield put({ type: SET_VIDEOS, payload: videos });
		// console.log('getVideos', videos);
	} catch (error) {
		console.log('getVideos res error', error);
	}
}

function* getVideosProm() {
	try {
		const videos = yield call(firebaseGetProm);
		yield put({ type: SET_VIDEOS_PROM, payload: videos });
		// console.log('getVideosProm', videos);
	} catch (error) {
		console.log('getVideos res error', error);
	}
}

function* getVideosTesti() {
	try {
		const videos = yield call(firebaseGetTesti);
		yield put({ type: SET_VIDEOS_TESTI, payload: videos });
		console.log('getVideosTesti', videos);
	} catch (error) {
		console.log('getVideosTesti res error', error);
	}
}

function* getHomeVideo() {
	try {
		const bool = yield call(localGetHomeVideo);
		// console.log('getHomeVideo', bool);
		//if (bool) {
			const video = yield call(firebaseGetHomeVideo);
			yield put({ type: SET_HOME_VIDEO, payload: video });
		//}

		yield put({ type: SET_MENU_HIDE, payload: bool });
		yield put({ type: SET_HOME_SHOW_VIDEO, payload: bool });
	} catch (error) {
		console.log('getHomeVideo res error', error);
	}
}

const firebaseGet = () => {
	const firestore = firebase.firestore();
	return firestore.collection('database').doc('base').collection('videos').get().then(snap => {
		//console.log('firebaseGet', snap.size);
		let arr = [];
		snap.forEach(doc => arr.push(doc.data()));
		return arr;
	});
}

const firebaseGetProm = () => {
	const firestore = firebase.firestore();
	return firestore.collection('database').doc('base').collection('videosProm').get().then(snap => {
		let arr = [];
		snap.forEach(doc => arr.push(doc.data()));
		return arr;
	});
}

const firebaseGetTesti = () => {
	const firestore = firebase.firestore();
	return firestore.collection('database').doc('base').collection('testimonials').get().then(snap => {
		let arr = [];
		snap.forEach(doc => arr.push(doc.data()));
		return arr;
	});
}

const localGetHomeVideo = () => {
	return localforage.getItem('homeVideoVisualized')
		.then(item => {
			if(!item) {
				localforage.setItem('homeVideoVisualized', true);
				return true;
			}else{
				return false;
				//return true;
			}
		})
		.catch(e => {
			localforage.setItem('homeVideoVisualized', true);
			return true;
		});
}

const firebaseGetHomeVideo = () => {
	const firestore = firebase.firestore();
	return firestore.collection('database').doc('base').get().then(snap => {
		return snap.data().video || {}
	});
}


// WEBPACK FOOTER //
// ./src/sagas/videosSaga.js